import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useParentUrlListener() {
  const parentUrl = ref(null)
  const parentUrlVersion = ref(0)
  const LOG_PREFIX = '[ParentURL]'
  let messageHandler = null

  const updateParentUrl = (url) => {
    parentUrl.value = url
    parentUrlVersion.value += 1
  }

  const resolveParentUrl = () => {
    const inIframe = window !== window.parent
    console.log(`${LOG_PREFIX} resolveParentUrl() | inIframe=${inIframe}`)

    try {
      const url = window.parent.location.href
      updateParentUrl(url)
      console.log(`${LOG_PREFIX} resolved (direct) | url=${url}`)
    } catch (err) {
      console.warn(`${LOG_PREFIX} direct access blocked (cross-origin) | message=${err?.message}`)

      let referrerOrigin = null
      try {
        referrerOrigin = document.referrer ? new URL(document.referrer).origin : null
      } catch (e) {
        console.warn(`${LOG_PREFIX} invalid document.referrer | referrer=${document.referrer}`)
      }
      console.log(`${LOG_PREFIX} fallback: postMessage | referrerOrigin=${referrerOrigin ?? 'null'}`)

      messageHandler = (event) => {
        const type = event?.data?.type
        if (type !== 'parent-url') return

        if (!referrerOrigin || event.origin !== referrerOrigin) {
          console.log(`${LOG_PREFIX} message ignored (origin) | expected=${referrerOrigin} received=${event.origin}`)
          return
        }
        if (event.source !== window.parent) {
          console.log(`${LOG_PREFIX} message ignored (source !== window.parent)`)
          return
        }

        if (event.data?.url) {
          updateParentUrl(event.data.url)
          console.log(`${LOG_PREFIX} resolved (postMessage) | url=${event.data.url}`)
        }
      }

      window.addEventListener('message', messageHandler)

      if (window.parent !== window && referrerOrigin) {
        console.log(`${LOG_PREFIX} sending request-parent-url to origin=${referrerOrigin}`)
        window.parent.postMessage({ type: 'request-parent-url' }, referrerOrigin)
      } else {
        console.log(`${LOG_PREFIX} not sending request | hasParent=${window.parent !== window} referrerOrigin=${!!referrerOrigin}`)
      }
    }
  }

  onMounted(() => {
    resolveParentUrl()
  })

  onBeforeUnmount(() => {
    if (messageHandler) {
      window.removeEventListener('message', messageHandler)
    }
  })

  return {
    parentUrl,
    parentUrlVersion
  }
}
